import { auth } from '../../utils';
import config from '../../config';

export const checkPasswordStatusApi = async () => {
  const userGuid = auth.getAccessToken()?.guid;
  const url = `${config.mfaIssueTokenCheck.baseUrl}${userGuid}/password/status`;

  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${auth.getParsedAuthCookie()?.accessToken}`,
    },
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('No response');
  }
  const json = await response.json();
  return json.Result;
};
